import { ca } from '@cian/analytics';

export const trackSafeRentShow = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Show',
    category: 'SafeRent',
    label: 'Arrange_inspection_button',
    page: {
      pageType: 'Card',
    },
  });
};
export const trackSafeRentClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'SafeRent',
    label: 'Arrange_inspection_button',
    page: {
      pageType: 'Card',
    },
  });
};
export const trackSafeRentFormSend = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Click',
    category: 'SafeRent',
    label: 'Form',
    page: {
      pageType: 'Card',
    },
  });
};
export const trackSafeRentFormSentSuccess = () => {
  ca('eventSite', {
    name: 'oldevent',
    action: 'Success',
    category: 'SafeRent',
    label: 'Form_sent',
    page: {
      pageType: 'Card',
    },
  });
};
